import { CircularProgress, makeStyles, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { debounce } from "lodash";
import React from "react";
import { useCallback, useEffect, useState } from "react";
import { useDataProvider, useNotify } from "react-admin";
import { useField } from "react-final-form";

interface InvoiceInputProps {
  label: string;
  source: string;
  rateChartSource: string;
  rateChartId: number;
  creditNoteAmount: number;
}

const useStyles = makeStyles({
  root: {
    marginTop: "8px",
    paddingBottom: "3px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#EAEAEA",
      },
      "&:hover fieldset": {
        borderColor: "#EAEAEA",
      },
    },
  },
});

export default function InvoiceInput({
  label,
  source,
  rateChartSource,
  rateChartId,
  creditNoteAmount,
}: InvoiceInputProps) {
  const [optionValues, setOptionValues] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [parent, setParent] = useState<IParent>();

  const parentId = useField("parentId");
  const rateChartField = useField(rateChartSource);
  const invoiceReferenceNumber = useField(source);

  console.log("PARENT", parentId.input.value);
  console.log("INVOICE", invoiceReferenceNumber.input.value);

  const provider = useDataProvider();
  const notify = useNotify();
  const classes = useStyles();

  useEffect(() => {
    if (parentId.input.value !== "") {
      provider
        .getOne("parents", { id: Number(parentId.input.value) })
        .then(({ data }) => {
          setParent(data as IParent);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentId.input.value]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const callInvoiceListApi = useCallback(
    debounce((searchVal: string, mbcCustomerId: string) => {
      provider
        .customGetList("customerLedgers", {
          filter: {
            CustomerNo: mbcCustomerId,
            DocumentType: "Invoice",
            InvoiceNo: searchVal,
            Open: "true",
            MinimumAmount: creditNoteAmount,
          },
        })
        .then(({ data }: any) => {
          if (data.values.length > 0) {
            setOptionValues(
              data.values.map(
                (item: any) =>
                  `${item.no} - ${item.description} ($ ${item.remainingAmountLcy})`
              )
            );
            setLoading(false);
          } else {
            setOptionValues([]);
            setLoading(false);
          }
        })
        .catch((error: any) => {
          notify(`Error from MBC : ${error.message}`, "error");
          setOptionValues([]);
          setLoading(false);
        });
    }, 1000),
    []
  );

  useEffect(() => {
    invoiceReferenceNumber.input.onChange(null);
    rateChartField.input.onChange(rateChartId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (parent) {
      setLoading(true);
      callInvoiceListApi(
        invoiceReferenceNumber.input.value,
        parent.user.mbcCustomerId
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parent]);

  return (
    <Autocomplete
      className={classes.root}
      options={optionValues}
      onChange={(event, newValue, reason) => {
        if (reason === "select-option") {
          const splitedValue = newValue.split(" ");

          invoiceReferenceNumber.input.onChange(splitedValue[0]);
          rateChartField.input.onChange(rateChartId);
        }

        if (reason === "clear") {
          invoiceReferenceNumber.input.onChange(null);
          rateChartField.input.onChange(rateChartId);
        }
      }}
      value={invoiceReferenceNumber.input.value}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
